import axios from "axios";
import Auth from "./repositories/auth";

export const BASE_URL = process.env.REACT_APP_BASE_URL_EU;
export const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIEND_ID;

class Service {
  static instance;
  
  constructor() {
    this._client = axios.create({
      baseURL: `${BASE_URL}/api`,
      withCredentials: true
    });

    this.refreshTokenTimer = null;
    
    this._client.interceptors.response.use(
      (response) => {
        // Если это успешный логин или обновление токена, запускаем таймер
        if (
          (response.config.url.includes('/auth/login') || 
           response.config.url.includes('/auth/refresh')) && 
          response.status === 200
        ) {
          this.startRefreshTokenTimer();
        }
        return response;
      },
      async (error) => {
        const originalRequest = error.config;
        
        // Если получаем 401, значит токен истек или недействителен
        if (error.response?.status === 401) {
          if (!originalRequest._retry && 
              !originalRequest.url.includes('/auth/login') &&
              !originalRequest.url.includes('/auth/register') &&
              !originalRequest.url.includes('/auth/verify') &&
              !originalRequest.url.includes('/auth/refresh')) {
            
            originalRequest._retry = true;
            
            try {
              await this._client.post('/auth/refresh', {}, { withCredentials: true });
              return this._client(originalRequest);
            } catch (refreshError) {
              localStorage.removeItem('isAuthenticated');
              this.stopRefreshTokenTimer();
              
              if (!window.location.pathname.includes('/sign-in')) {
                window.location.href = '/sign-in';
              }
              return Promise.reject(refreshError);
            }
          }
        }
        
        return Promise.reject(error);
      }
    );

    this._client.interceptors.request.use((config) => {
      return config;
    });
    Service.instance = this;
    
    // Если пользователь уже авторизован, запускаем таймер обновления токена
    if (localStorage.getItem('isAuthenticated') === 'true') {
      this.startRefreshTokenTimer();
    }
  }

  startRefreshTokenTimer() {
    this.stopRefreshTokenTimer();
    
    this.refreshTokenTimer = setInterval(async () => {
      try {
        await this._client.post('/auth/refresh', {}, { withCredentials: true });
        console.log('Token refreshed successfully');
      } catch (error) {
        console.error('Failed to refresh token:', error);
        this.stopRefreshTokenTimer();
        localStorage.removeItem('isAuthenticated');
        
        // Перенаправляем на страницу входа, если мы не на ней
        if (!window.location.pathname.includes('/sign-in')) {
          window.location.href = '/sign-in';
        }
      }
    }, 15 * 60 * 1000); // 15 минут
  }

  // Метод для остановки таймера
  stopRefreshTokenTimer() {
    if (this.refreshTokenTimer) {
      clearInterval(this.refreshTokenTimer);
      this.refreshTokenTimer = null;
    }
  }

  static getInstance() {
    if (Service.instance) {
      return Service.instance;
    }
    return new Service();
  }

  repeatRequest = async (originalRequest) => {
    const token = localStorage.getItem("access_token");
    originalRequest.headers.Authorization = `Bearer ${token}`;
    return new Promise((resolve, reject) => {
      this._client(originalRequest)
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }
}

export default Service.getInstance()._client;
